import * as types from './_actionTypes';

const initialState = {
  stats: {
    totalColleges: 0,
    totalStudents: 0,
    totalSMEs: 0,
    totalCertificates: 0,
    pendingApprovals: 0
  },
  recentActivities: [],
  loading: false,
  error: null
};

const adminDashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_ADMIN_STATS_REQUEST:
    case types.FETCH_RECENT_ACTIVITIES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    
    case types.FETCH_ADMIN_STATS_SUCCESS:
      return {
        ...state,
        loading: false,
        stats: action.payload,
        error: null
      };
    
    case types.FETCH_RECENT_ACTIVITIES_SUCCESS:
      return {
        ...state,
        loading: false,
        recentActivities: action.payload,
        error: null
      };
    
    case types.FETCH_ADMIN_STATS_FAILURE:
    case types.FETCH_RECENT_ACTIVITIES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    
    default:
      return state;
  }
};

export default adminDashboardReducer;